import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'

export interface MenuItemProps {
  title?: string
  description?: string
  icon?: IconProp | IGatsbyImageData
  iconColor?: string
  iconBackgroundColor?: string
  iconImageSharp?: boolean
}

const MenuItem = ({
  title,

  description,
  icon,
  iconColor,
  iconBackgroundColor,
  iconImageSharp = false,
}: MenuItemProps) => (
  <>
    {icon ? (
      <div
        className="menu-item-icon"
        style={{
          backgroundColor: iconBackgroundColor
            ? iconBackgroundColor
            : undefined,
          color: iconColor ? iconColor : undefined,
        }}
      >
        {!iconImageSharp ? (
          <FontAwesomeIcon icon={icon as IconProp} />
        ) : (
          <GatsbyImage
            image={icon as IGatsbyImageData}
            alt={title ?? ''}
            imgStyle={{ objectFit: 'contain' }}
          />
        )}
      </div>
    ) : null}
    <div className="menu-item-text">
      {title && <span className="menu-item-title">{title}</span>}
      {description && (
        <span className="menu-item-description">{description}</span>
      )}
    </div>
  </>
)

export default MenuItem
